define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/session",
	"csi/state",
	"csi/table/Widget",
	"csi/xml",
	"csi/xml/Query"
], function(declare,_,session,state,Table,xml,Query) {

	return declare(Table, {

		postMixInProperties: function() {
			// summary: determine if active product color is specified in browser location (such as when print from DataPackage)
			if (state.get("print") && !state.get("printAdHoc")) {
				var url = session.getLocationValue("ProductSalesRegion");

				if (xml.isValidURL(url)) {
					this.viewParent.activeProductSalesRegion = url;
				}
			}

			this.inherited(arguments);
		},

		_createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
			// summary: add filter if specified in page location
			var ql = this.inherited(arguments);

			var activeProductSalesRegion;

			if (this.viewParent)
				activeProductSalesRegion = this.viewParent.activeProductSalesRegion;

			if (xml.isValidURL(activeProductSalesRegion)) {
				var salesRegions = [activeProductSalesRegion];

				var activeProductSalesRegionNode = this.getCache().getNode(activeProductSalesRegion);
				if (activeProductSalesRegionNode && activeProductSalesRegionNode.SecondaryProductSalesRegions) {
					salesRegions = salesRegions.concat(activeProductSalesRegionNode.SecondaryProductSalesRegions);
				}

				var q = new Query();

				_.each(salesRegions, function(region) {
					this.RefAttr("ProductSalesRegion", xml.OP_EQUALS, region);
				}, q.Or());

			}

			ql.serverQuery = q;

			return ql;
		}

	});
});
